import { render } from "./Recruit.vue?vue&type=template&id=12c198ca&scoped=true"
import script from "./Recruit.vue?vue&type=script&lang=js"
export * from "./Recruit.vue?vue&type=script&lang=js"

import "./Recruit.vue?vue&type=style&index=0&id=12c198ca&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12c198ca"]])

export default __exports__